export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            投稿爆料
          </h2>
          <p className="text-sm text-foreground-500 mb-8 md:mb-10">
            你有独家猛料？欢迎投稿！吃瓜群众的力量，让每一颗大瓜都不被埋没
          </p>

          <div className="bg-background-100 border border-background-200/70 rounded-2xl p-6 md:p-8">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 md:gap-6">
              <div className="text-center">
                <div className="w-14 h-14 mx-auto rounded-full bg-primary-50 flex items-center justify-center mb-3">
                  <i className="ri-mail-line text-2xl text-primary-500"></i>
                </div>
                <h3 className="text-sm font-medium text-foreground-800 mb-1">邮箱投稿</h3>
                <p className="text-xs text-foreground-400">tips@51chigua.com</p>
              </div>
              <div className="text-center">
                <div className="w-14 h-14 mx-auto rounded-full bg-accent-50 flex items-center justify-center mb-3">
                  <i className="ri-wechat-line text-2xl text-accent-500"></i>
                </div>
                <h3 className="text-sm font-medium text-foreground-800 mb-1">微信投稿</h3>
                <p className="text-xs text-foreground-400">搜索：51吃瓜小助手</p>
              </div>
              <div className="text-center">
                <div className="w-14 h-14 mx-auto rounded-full bg-secondary-50 flex items-center justify-center mb-3">
                  <i className="ri-shield-check-line text-2xl text-secondary-500"></i>
                </div>
                <h3 className="text-sm font-medium text-foreground-800 mb-1">匿名保护</h3>
                <p className="text-xs text-foreground-400">严格保护爆料人隐私</p>
              </div>
            </div>

            <div className="mt-8 pt-6 border-t border-background-200/70">
              <p className="text-xs text-foreground-400 leading-relaxed">
                我们承诺对所有投稿信息严格保密，爆料人身份绝不外泄。所有稿件经核实后将第一时间发布，与百万吃瓜群众共同见证。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}